export class Header {
    activate() {
        const menu_items = document.querySelectorAll('header .headerMenu__item');

        document.body.addEventListener('click', (e) =>{
            if (!$(e.target).hasClass('headerMenu__link')){
                $('.headerSubMenu-wrapper').slideUp();
            }
        });

        menu_items.forEach( (menuItem) => {
            let offset = 0;
            let link = menuItem.querySelector('.headerMenu__link');

            if (link) {
                let anchor = link.dataset.anchor;

                offset = parseInt(link.dataset.offset);
                if (!offset) {
                    offset = 0;
                }

                if (document.querySelector(`${anchor}`)) {
                    link.addEventListener('click', function (e) {
                        e.preventDefault();

                        $([document.documentElement, document.body]).animate({
                            scrollTop: $(anchor).offset().top - offset,
                        }, 2000);
                    });
                }
            }

            if(menuItem.classList.contains('headerMenu__item--hasChild')){
                menuItem.addEventListener('click', (e)=> {

                        let viewportWidth = $(window).width();
                        if(viewportWidth > 1324) {
                            if ($('.headerSubMenu-wrapper').is(':visible')) {
                                $('.headerSubMenu-wrapper').hide();
                            }
                        }

                    let target = e.target;
                    let hash = target.getAttribute('href');

                    if(hash === '#'){
                        e.preventDefault();
                        $(menuItem).find('.headerSubMenu-wrapper').slideToggle();
                    }
                })
            }
        });
    }
}